import React from 'react'
import PropTypes from 'prop-types'
import * as Styled from './BarGraph.styles'

/**
 * /**
 * for use in result tile type hospital
 * @param percent
 * @param showAverage
 * @param average
 * @param className
 * @returns {*}
 * @constructor
 */
const BarGraph = ({
  percent = 0,
  showAverage = false,
  average = 0,
  className = '',
}) => (
  <Styled.Container className={ className } averagePercent={ average }>
    <div className={ 'bar-graph-wrapper' }>
      <Styled.graphBackground />
      <Styled.graph percent={ percent } />
      {showAverage && average !== 0 && (
        <div
          className={ 'bar-graph-average' }
          data-testid={ 'bar-graph-average' }
        />
      )}
    </div>
    <Styled.Value>{percent} %</Styled.Value>
  </Styled.Container>
)

BarGraph.propTypes = {
  /* percent value */
  percent: PropTypes.number.isRequired,
  /* optional average value */
  average: PropTypes.number,
  showAverage: PropTypes.bool,
  className: PropTypes.string,
}

export default BarGraph
